var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guideline",attrs:{"id":"guideline"}},[_c('headline',[_vm._v("Guideline")]),_c('router-link',{staticClass:"guide_link",attrs:{"to":"guide"}},[_c('guide-title',{attrs:{"tag_type":"span"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }